/**
 * Thermal receipt PDF generator (80mm printer format).
 * Used to print a quick summary when a day is closed.
 */

import html2pdf from 'html2pdf.js';
import { pad, fmtPLN } from './helpers';

export const generateThermalPDF = async ({ targetDate, entries, locationName, username }) => {
  const dayEntries = entries.filter((e) => e.date === targetDate);
  if (dayEntries.length === 0) {
    console.log('No entries for this day, skipping thermal PDF generation');
    return;
  }

  let totalKitchen = 0;
  for (const e of dayEntries) {
    totalKitchen += Number(e.kitchen || 0);
  }

  const now = new Date();
  const timestamp = `${targetDate} ${pad(now.getHours())}:${pad(now.getMinutes())}`;

  const html = `
    <div style="font-family: Arial, sans-serif; width: 270px; padding: 8px 10px; color: #000; background: #fff; font-size: 14px; line-height: 1.6; font-weight: bold;">
      <div style="text-align: center; border-bottom: 3px solid #000; padding-bottom: 10px; margin-bottom: 10px;">
        <div style="font-size: 18px; font-weight: 900; letter-spacing: 2px; margin-bottom: 4px;">MR JERRY</div>
        <div style="font-size: 15px; font-weight: 900;">ROZLICZENIE DNIA</div>
      </div>
      <div style="margin: 12px 0; font-size: 13px; line-height: 1.8;">
        <div style="margin-bottom: 4px;"><strong>Lokal:</strong> ${locationName}</div>
        <div style="margin-bottom: 4px;"><strong>Data:</strong> ${targetDate}</div>
        <div><strong>Zamknięty:</strong> ${username}</div>
      </div>
      <div style="border-top: 2px dashed #000; border-bottom: 2px dashed #000; padding: 8px 0; margin: 12px 0; text-align: center;">
        <div style="font-size: 15px; font-weight: 900;">PODSUMOWANIE</div>
      </div>
      <div style="text-align: center; margin: 16px 0; padding: 12px 0; border: 3px double #000;">
        <div style="font-size: 14px; font-weight: 900; margin-bottom: 6px;">KUCHNIA (40%)</div>
        <div style="font-size: 22px; font-weight: 900; letter-spacing: 1px;">${fmtPLN(totalKitchen)} zł</div>
      </div>
      <div style="border-top: 3px solid #000; margin-top: 16px; padding-top: 10px; text-align: center; font-size: 12px; line-height: 1.6;">
        <div style="font-size: 16px; font-weight: 900; margin-bottom: 3px;">MR JERRY</div>
        <div style="font-weight: bold;">${timestamp}</div>
      </div>
    </div>
  `;

  const container = document.createElement('div');
  container.innerHTML = html;
  document.body.appendChild(container);

  await html2pdf()
    .set({
      margin: 0,
      filename: `mrjerry_napiwki_${targetDate}.pdf`,
      image: { type: 'jpeg', quality: 1.0 },
      html2canvas: { scale: 3, useCORS: false, logging: false, backgroundColor: '#ffffff' },
      jsPDF: { unit: 'mm', format: [80, 297], orientation: 'portrait', compress: false },
    })
    .from(container.firstElementChild)
    .save();
  document.body.removeChild(container);
};
